import React from "react";
import Title from "antd/lib/typography/Title";
import { MinusOutlined, PlusOutlined } from "@ant-design/icons";
import { Button, Card } from "antd";
import { connect } from "dva";
import { AvailableNowOptions, dateStringToStandardFormat } from "@/utils/dateFormatter";
import { TrailerTypeMap } from "@/utils/enum";
import { formatDistance, formatPrice } from "@/utils/utils";
import ShipmentStatusTracker from "./ShipmentStatusTracker";

const ShipmentStatusCard = props => {
  const { shipmentData, showMap, dispatch } = props;

  return (
    <Card
      title="Status"
      style={{ marginBottom: 16 }}
      bodyStyle={{ padding: 24, paddingTop: 0 }}
      headStyle={{ borderBottomWidth: 0 }}
    >
      <div style={{ display: "flex", flexDirection: "column" }}>
        <ShipmentStatusTracker />
        <div
          style={{
            display: "flex",
            paddingTop: 16,
          }}
        >
          <section style={{ display: "flex", gap: 8, flexDirection: "column" }}>
            {shipmentData?.vehicles?.length > 0 && (
              <Title level={5} style={{ marginBottom: 0, marginRight: 50, marginTop: 0 }}>
                Price:{" "}
                {formatPrice(shipmentData.vehicles.reduce((acc, curr) => acc + Number(curr?.quote?.dealerPrice), 0))}
              </Title>
            )}

            <section
              style={{
                display: "flex",
                gap: 8,
                justifyContent: "flex-start",
              }}
            >
              <Title level={5} style={{ marginBottom: 0, marginRight: 50, marginTop: 0 }}>
                Distance: {formatDistance(shipmentData.distance)} miles
              </Title>
              <Title level={5} style={{ marginBottom: 0, marginRight: 50, marginTop: 0 }}>
                Availability:{" "}
                {dateStringToStandardFormat(shipmentData?.availableAt, {
                  availableNowModifier: shipmentData?.availableNow
                    ? AvailableNowOptions.IsAvailableNow
                    : AvailableNowOptions.NotAvailableNow,
                })}
              </Title>
              <Title level={5} style={{ marginBottom: 0, marginRight: 50, marginTop: 0 }}>
                Trailer Type: {TrailerTypeMap[shipmentData?.trailerType]}
              </Title>
            </section>
          </section>

          <section
            style={{
              display: "flex",
              gap: 8,
              flexDirection: "column",
              justifyContent: "flex-end",
              alignItems: "flex-end",
              flex: 1,
            }}
          >
            <Button
              type="link"
              icon={showMap ? <MinusOutlined /> : <PlusOutlined />}
              onClick={() => {
                dispatch({
                  type: "shipmentDetails/toggleMapVisible",
                  payload: !showMap,
                });
              }}
              style={{ padding: 0 }}
            >
              {showMap ? "Hide Map" : "Show Map"}
            </Button>
          </section>
        </div>
      </div>
    </Card>
  );
};

export default connect(({ shipmentDetails }) => ({
  shipmentData: shipmentDetails.data,
  showMap: shipmentDetails.showMap,
}))(ShipmentStatusCard);
